import Header from "../Components/Header/Header";

const NotFound = () => {
  return(
    <div>
        <Header />
      <div className="Page">

        <div className="Error">
        <h1>404</h1>
        <h2>Такой страницы не существует</h2>        
        </div>

      </div>
    </div>
  );
}
export default NotFound;